import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { Comment, Post, Like } from '../models/feed-model';

const DAY = 86400000;
@Injectable({
  providedIn: 'root',
})
export class FeedService {
  private last24hours = new Date().getTime() - DAY;
  constructor(private angularFireStore: AngularFirestore) {}

  posts$ = this.angularFireStore
    .collection(`posts`, (ref) =>
      ref.where('date', '>=', this.last24hours).orderBy('date', 'desc')
    )
    .valueChanges({ idField: 'id' })
    .pipe(catchError(this.handleError));

  getUserPost(user: string) {
    return this.angularFireStore
      .collection(`posts`, (ref) => ref.where('owner', '==', user))
      .valueChanges({ idField: 'id' })
      .pipe(catchError(this.handleError));
  }

  createPost(post) {
    return this.angularFireStore.collection(`posts`).add(post);
  }

  deletePost(postId: string) {
    return this.angularFireStore.collection(`posts`).doc(postId).delete();
  }

  commentPost(postId: string, comment: Comment) {
    return this.angularFireStore
      .collection(`posts/${postId}/comments`)
      .doc(`${comment.date}`)
      .set(comment);
  }

  likePost(postId: string, like: Like) {
    return this.angularFireStore
      .collection(`posts/${postId}/likes`)
      .doc(`${like.uid}`)
      .set(like);
  }

  unlikePost(postId: string, like: Like) {
    return this.angularFireStore
      .collection(`posts/${postId}/likes`)
      .doc(`${like.uid}`)
      .delete();
  }

  // Likes
  updatePost(id, fields) {
    return this.angularFireStore
      .collection(`users`)
      .doc(`${id}`)
      .update(fields);
  }

  getComments(id) {
    return this.angularFireStore
      .collection(`/posts/${id}/comments`)
      .valueChanges();
  }

  getLikes(id) {
    return this.angularFireStore
      .collection(`/posts/${id}/likes`)
      .valueChanges();
  }

  private handleError(err: any) {
    // in a real world app, we may send the server to some remote logging infrastructure
    // instead of just logging it to the console
    let errorMessage: string;
    if (err.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      errorMessage = `An error occurred: ${err.error.message}`;
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      errorMessage = `Backend returned code ${err}`;
    }
    console.log(err);
    return throwError(errorMessage);
  }
}
